import { Box } from "@chakra-ui/react";
import { Apple } from "lucide-react";

interface StoreIconProps {
  readonly size?: number;
}

export function AppleStoreIcon({ size = 18 }: StoreIconProps) {
  return <Apple size={size} />;
}

export function GooglePlayIcon({ size = 18 }: StoreIconProps) {
  return (
    <Box
      as="svg"
      aria-hidden="true"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      flex="0 0 auto"
    >
      <path
        d="M5.2 3.4c-.42.25-.7.75-.7 1.43v14.34c0 .68.28 1.18.7 1.43l7.9-8.6-7.9-8.6Z"
        fill="#00D6FF"
      />
      <path
        d="m15.33 9.56-2.23 2.43 2.24 2.44 3.13-1.8c.72-.42.72-1.62 0-2.04l-3.14-1.03Z"
        fill="#FFD84D"
      />
      <path
        d="m5.92 3.03 8.42 5.98-2.37 2.58-6.05-8.56Z"
        fill="#32F38B"
      />
      <path
        d="m5.92 20.97 6.05-8.56 2.37 2.58-8.42 5.98Z"
        fill="#FF4FD8"
      />
    </Box>
  );
}
